import Vue from 'vue';
import Vuex from 'vuex';

import admin from '~/store/modules/admin';
import app from '~/store/modules/app';
import component from '~/store/modules/component';
import contents from '~/store/modules/contents';
import debug from '~/store/modules/debug';
import inits from '~/store/modules/inits';
import input from '~/store/modules/input';
import langs from '~/store/modules/langs';
import message from '~/store/modules/message';
import page from '~/store/modules/page';
import point from '~/store/modules/point';
import recruitments from '~/store/modules/recruitments';
import sales from '~/store/modules/sales';
import styles from '~/store/modules/styles';
import trainings from '~/store/modules/trainings';
import user from '~/store/modules/user';
import versionInfo from '~/store/modules/versionInfo';

Vue.use(Vuex)

export default new Vuex.Store({
	modules: {
		admin: admin,
		app: app,
		component: component,
		contents: contents,
		debug: debug,
		inits: inits,
		input: input,
		langs: langs,
		message: message,
		page: page,
		point: point,
		recruitments: recruitments,
		sales: sales,
		styles: styles,
		trainings: trainings,
		user: user,
		versionInfo: versionInfo
	},
	
	state: {},

	getters: {},

	mutations: {},

	actions: {}
})
